module.exports = __webpack_public_path__ + "static/img/logo2.1806ac51.png";